import React, { memo, forwardRef, useImperativeHandle, useState, useCallback } from "react";
import Modal from "@mui/material/Modal";
import PropTypes from "prop-types";

import api from "services/api";
import serveRequestErrors from "common/serve-request-errors";
import AppButton from "components/app-button";

export const AppCancelClaimModal = (props, ref) => {
	const [isSubmitting, setSubmitting] = useState();
	const [visible, setVisible] = useState(false);
	const [claimId, setClaimId] = useState({});

	const onHandleShow = useCallback((id) => {
		setClaimId(id);
		setVisible(true);
	}, []);

	const onHandleDismiss = useCallback(() => {
		setVisible(false);
	}, []);

	const onHandleDelete = async () => {
		let response = null;
		setSubmitting(true);

		try {
			await api.post.claims.cancel(claimId);
			response = true;
		} catch (error) {
			serveRequestErrors(error);
		} finally {
			setSubmitting(false);
		}

		if (response) {
			onHandleDismiss();
			props.onHandleGetList();
		}
	};

	//prettier-ignore
	useImperativeHandle(ref, () => ({
		onHandleShow: onHandleShow,
		onHandleDismiss: onHandleDismiss,
	}));

	return (
		<Modal classes={{ root: "app-cancel-claim-modal" }} open={visible} onClose={onHandleDismiss} aria-labelledby="cancel-claim-modal" aria-describedby="cancel-claim-modal">
			<div className="cancel-claim-modal">
				<div className="cancel-claim-modal__main">
					<div className="cancel-claim-modal__header">
						<p className="cancel-claim-modal__title">Cancel Claim</p>
					</div>

					<div className="cancel-claim-modal__body">
						<p className="cancel-claim-modal__description">Are you sure want to cancel this claim?</p>

						<div className="cancel-claim-modal__button-container">
							<AppButton type="button" label="Cancel" outline onClick={onHandleDismiss} />
							<AppButton type="submit" label="Confirm" onClick={onHandleDelete} disabled={isSubmitting} />
						</div>
					</div>
				</div>
			</div>
		</Modal>
	);
};

export default memo(forwardRef(AppCancelClaimModal));

AppCancelClaimModal.propTypes = {
	ref: PropTypes.object,
};
